export default (function (array, callback) {
  return array.reduce(function (partialObject, element) {
    return callback(partialObject, element);
  }, {});
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions/es/arrayToObject.js
// module id = 933
// module chunks = 0